import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './App.js';
import { ReleaseIdentifier } from './releaseIdentifier.js';
import { installAutomaticServiceWorkerUpdates } from './serviceWorkerUpdates.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

if ('serviceWorker' in navigator) {
  installAutomaticServiceWorkerUpdates({
    serviceWorker: navigator.serviceWorker,
    document,
    reload: () => window.location.reload(),
  });
}

createRoot(container).render(
  <StrictMode>
    <App />
    <ReleaseIdentifier releasedAt={__APP_RELEASE_DATE__} />
  </StrictMode>,
);
